import { makeAutoObservable, runInAction } from 'mobx';
import fetchService from '../servises/fetch.service';

export class MetricsStore {
    constructor() {
        makeAutoObservable(this);
    }

    spikesByServerId = {};
    since = '10min'; // 5min, 30min, 1hour, 2hours, 6hours, 12hours, 24hours
    selectorLoading = false;
    requestSequenceByKey = {};
    pendingRequests = 0;

    async getSpikes(serverId, type) {
        const cacheKey = serverId + type;
        const requestSequence = (this.requestSequenceByKey[cacheKey] || 0) + 1;
        this.requestSequenceByKey[cacheKey] = requestSequence;
        runInAction(() => {
            this.pendingRequests += 1;
            this.selectorLoading = true;
        });
        try {
            const response = await fetchService.authenticatedGet(
                `/spikes/${ serverId }?type=${ type }`);
            const data = response.data.data_o;
            runInAction(() => {
                if (this.requestSequenceByKey[cacheKey] !== requestSequence) {
                    return;
                }
                this.spikesByServerId = {
                    ...this.spikesByServerId,
                    [cacheKey]: data
                };
            });
        } finally {
            runInAction(() => {
                this.pendingRequests -= 1;
                this.selectorLoading = this.pendingRequests > 0;
            });
        }
    }

}

const metricsStore = new MetricsStore();

export default metricsStore;
